import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import {Observable} from "rxjs";

const API_URL = environment.apiUrl + 'events/';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  constructor(private http: HttpClient) {}

  createEvent(event: any) {
    return this.http.post(API_URL + '', event, { responseType: 'json' });
  }

  getEvents(filter: any, limit: number, order: any[]) {
    const data = {
      filter: filter,
      limit: limit,
      order: order
    }
    return this.http.post(API_URL + 'search', data, { responseType: 'json' });
  }

  countEvents(filter: any): Observable<any> {
    return this.http.post(API_URL + 'search/count', filter, { responseType: 'json' });
  }

  updateEvent(id: string, event: any) {
    return this.http.put(API_URL + id, event, { responseType: 'json' });
  }

}
